module.exports = __webpack_public_path__ + "static/media/gfl-news-mobile.81c09998.png";